import { render, staticRenderFns } from "./TypeFileXLSIcon.vue?vue&type=template&id=c863897e&"
import script from "./TypeFileXLSIcon.vue?vue&type=script&lang=js&"
export * from "./TypeFileXLSIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports